import { Calculation } from '@servicetitan/financing-api-client';
import { PreApprovalDto } from '@servicetitan/financing-api-client/src/prequals-api';
import { AmountRangeStatus } from './amountRange';
import { PreApprovalEligibility } from './usePreApprovalEligibility';

export type AmountRangePreApprovalDisplay =
    | { kind: 'hidden' }
    | { kind: 'loading'; preApproval?: PreApprovalDto }
    | {
          kind: 'visible';
          preApproval: PreApprovalDto;
          calculation: Calculation;
          generalDisclosure: string;
      }
    | {
          kind: 'outOfRange' | 'unavailable';
          preApproval: PreApprovalDto;
          calculation: Calculation;
          generalDisclosure: string;
      };

export const projectPreApprovalDisplay = (
    amountRangeStatus: AmountRangeStatus,
    eligibility: PreApprovalEligibility,
): AmountRangePreApprovalDisplay => {
    if (amountRangeStatus === 'never-in-range' || eligibility.kind === 'absent') {
        return { kind: 'hidden' };
    }

    if (amountRangeStatus === 'loading') {
        return eligibility.kind === 'loading'
            ? { kind: 'loading', preApproval: eligibility.preApproval }
            : { kind: 'hidden' };
    }

    if (amountRangeStatus === 'out-of-range') {
        return eligibility.kind === 'out-of-range' && eligibility.calculation
            ? {
                  kind: 'unavailable',
                  preApproval: eligibility.preApproval,
                  calculation: eligibility.calculation,
                  generalDisclosure: eligibility.generalDisclosure,
              }
            : { kind: 'hidden' };
    }

    if (eligibility.kind === 'loading') {
        return { kind: 'loading', preApproval: eligibility.preApproval };
    }

    if (eligibility.kind === 'in-range') {
        return {
            kind: 'visible',
            preApproval: eligibility.preApproval,
            calculation: eligibility.calculation,
            generalDisclosure: eligibility.generalDisclosure,
        };
    }

    if (!eligibility.calculation) {
        return { kind: 'hidden' };
    }

    return {
        kind: 'outOfRange',
        preApproval: eligibility.preApproval,
        calculation: eligibility.calculation,
        generalDisclosure: eligibility.generalDisclosure,
    };
};
